import common from "./common";
import users from "./users";
import companies from "./companies";
import products from "./products";
import orders from "./orders";
import reports from "./reports";
import passports from "./passports";
import marketing from "./marketing";

export default {
  ...common,
  ...users,
  ...companies,
  ...products,
  ...orders,
  ...reports,
  ...passports,
  ...marketing
};
